import userApi from 'api/userApi';
import { useAppDispatch, useAppTranslation } from 'app/hooks';
import { onChangeAuthPage } from 'features/home/homeSlice';
import { getLocalStorage } from 'utils/sessionStorage';

const useCheckKYCForPoker = () => {
  const dispatch = useAppDispatch();
  const t = useAppTranslation();

  const checkKYC = async (afterCheck: () => void) => {
    if (!getLocalStorage('access_token_terabet')) {
      dispatch(onChangeAuthPage(1));
      return;
    }

    const { ok, body } = await userApi.getUser();
    if (!ok || !body) {
      return;
    }

    const { kyc, isTester } = body;

    if (isTester) {
      afterCheck();
      return;
    }

    // if (!kyc || kyc.status === 'INPROGRESS' || kyc.status === 'RETRY') {
    //   showConfirmModal({
    //     title: t('popup.kyc.title.required'),
    //     content: <p>{`${t('popup.kyc.message.kycRequired')}`}</p>,
    //     width: 360,
    //     icon: <WarningIcon />,
    //     onOk: () => {
    //       navigate('/kyc');
    //     },
    //     okText: t('popup.buttons.ok'),
    //     cancelText: t('popup.buttons.cancel'),
    //   });
    //   return;
    // }
    // if (kyc.status === 'REJECTED') {
    //   showInfoModal({
    //     title: t('popup.kyc.title.required'),
    //     content: <p>{t('popup.kyc.message.rejected')}</p>,
    //     width: 360,
    //     icon: <WarningIcon />,
    //   });
    //   return;
    // }
    // if (kyc.status === 'PENDING') {
    //   showInfoModal({
    //     title: t('popup.kyc.title.required'),
    //     content: <p>{t('popup.kyc.message.underReview')}</p>,
    //     width: 360,
    //     icon: <WarningIcon />,
    //   });
    //   return;
    // }

    afterCheck();
  };

  return { checkKYC };
};

export default useCheckKYCForPoker;
